import { render, staticRenderFns } from "./ApproveRequest.vue?vue&type=template&id=75beca77&"
import script from "./ApproveRequest.vue?vue&type=script&lang=js&"
export * from "./ApproveRequest.vue?vue&type=script&lang=js&"
import style0 from "./ApproveRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports